import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { FormValidationService } from './form-validation.service';

@Directive({
  selector: '[appValidationBorder]',
  standalone: true
})
export class ValidationBorderDirective {

  constructor(private renderer: Renderer2,
    hostElement: ElementRef,
    private formValidationService: FormValidationService) {
    this.formValidationService.errorSubject.subscribe(newErrorList => {

      // If form field is invalid - add the invalid class
      if (newErrorList.filter(err => err.field == hostElement.nativeElement.id).length > 0) {
        renderer.addClass(hostElement.nativeElement, 'ng-invalid');
      } else {
        renderer.removeClass(hostElement.nativeElement, 'ng-invalid');
      }

      // If form field has a requried validator and is empty - add the requried class
      if (this.formValidationService.fieldHasRequiredValidator(hostElement.nativeElement.id)) {
        renderer.addClass(hostElement.nativeElement, 'g-required-field');
      } else {
        renderer.removeClass(hostElement.nativeElement, 'g-required-field');
      }
    });
  }
}
